(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-page-main-article"] && !Shopify.designMode) return;
  try {
    
  
  $(document).ready(function () {
      var toc = $('<ul></ul>');
      var lastMainHeading;
      var idCounts = {};
    
      $('.article-main-content').find('h1, h2, h3').each(function () {
        var $heading = $(this);
        var tag = this.tagName.toLowerCase();
        var rawText = $heading.text(); // Preserve the original text for display
    
        // Clean text for ID: remove all non-alphanumeric except spaces, then replace spaces with hyphens
        var cleanedText = rawText.replace(/[^a-zA-Z0-9 ]/g, '').trim();
        var baseId = cleanedText.toLowerCase().replace(/\s+/g, '-');
        var uniqueId = baseId;
        var count = idCounts[baseId] || 0;
    
        // Make ID unique
        while (document.getElementById(uniqueId)) {
          count++;
          uniqueId = baseId + '-' + count;
        }
        idCounts[baseId] = count;
    
        $heading.attr('id', uniqueId); // Assign ID to the heading
    
        // Use raw text for the TOC link label, but cleaned/encoded href
        var link = $('<a></a>').attr('href', '#' + uniqueId).text(rawText);
    
        if (tag === 'h1' || tag === 'h2') {
          var li = $('<li class="main-heading"></li>').append(link);
          toc.append(li);
          lastMainHeading = li;
        } else if (tag === 'h3' && lastMainHeading) {
          var subList = lastMainHeading.children('ul');
          if (subList.length === 0) {
            subList = $('<ul class="sub-headings"></ul>');
            lastMainHeading.append(subList);
          }
          subList.append($('<li class="sub-heading"></li>').append(link));
        }
      });
    
      // Append TOC
      $('.table-of-content .table-content').append(toc);
    
      // Smooth scroll
      $('.table-of-content .table-content').on('click', 'a', function (e) {
        e.preventDefault();
        var targetId = $(this).attr('href').substring(1);
        var target = document.getElementById(targetId);
        if (target) {
          $('html, body').animate({
            scrollTop: $(target).offset().top - 150
          }, 500);
        }
      });
    
  
        $('.table-content ul a').click(function(){
            $('.table-content ul a').removeClass('active');
            $(this).addClass('active');
        })


          // Scroll event to update active TOC link based on scroll position
          $(window).on('scroll', function () {
            var scrollPosition = $(window).scrollTop() + 160; // 150 offset + 10 buffer
        
            var currentId = null;
        
            // Loop through all headings to find the one currently in view
            $('.article-main-content').find('h1, h2, h3').each(function () {
              var $heading = $(this);
              if ($heading.offset().top <= scrollPosition) {
                currentId = $heading.attr('id');  // Keep updating until the last heading above scrollPosition
              }
            });
        
            if (currentId) {
              $('.table-content ul a').removeClass('active');
              $('.table-content ul a[href="#' + currentId + '"]').addClass('active');
            }
          });
  });
  
  $('.toc-nav-mobile').click(function(){
      $(this).toggleClass('active');
  })

  


  
  $('.product-article').each(function() {
      var productHandle = $(this).data('product-handle'); // Get the product handle from the data attribute
      var $productArticle = $(this); // Store reference to the product-article element
      var productBadge = products_type_below_title.find(function(product) {
        return product.handle === productHandle;
      });
      
      $.ajax({
          url: `/products/${productHandle}.js`,  // Endpoint using the handle
          method: 'GET',
          dataType: 'json',
          success: function(product) {
          
              $productArticle.html(`
              
                  ${
                    product.variants[0].compare_at_price > product.variants[0].price
                      ? `<span class="discount-tag pp-medium body">Save ${formatMoney(product.variants[0].compare_at_price - product.variants[0].price, shopMoneyFormatNoDecimals)}</span>`
                      : ''
                  }
                  <div class="inner-product">
                      <div class="row">
                          <div class="col-lg-4 col-md-4 col-sm-12">
                              <div class="featured-image mt-lg-4 mt-md-4 mt-sm-0">
                                <img loading="lazy" src="${product.featured_image}" width="100%" height="100%">
                              </div>
                          </div>
                          <div class="col-lg-8 col-md-8 col-sm-12">
                              <h3 class="pp-semibold body-xl f-black mb-2 p-0">
                                  ${product.title}
                              </h3>
                              <p class="pp-regular f-gray body mb-2">
                                  ${productBadge.product_type_below_title}
                              </p>
                              <div class="product-description pp-medium body mb-3 p-0">
                                  ${product.description}
                              </div>
                              <div class="bottom-buttons col-lg-10 col-md-10 col-sm-12">
                                  <div class="d-flex align-items-center justify-content-center gap-lg-3 gap-md-3 gap-sm-1">
                                  
                                        <a href="${product.url}" class="btn-learn-more">
                                            <span class="pp-medium body-sm">
                                                Learn More
                                            </span>
                                        </a>
                                        <button class="btn-buy-now btn--buy-now" data-variant-id="${product.variants[0].id }" data-qty="1">
                                            <span class="pp-semibold price">
                                                ${formatMoney(product.variants[0].price, shopMoneyFormat)}
                                            </span>
                                            <span class="pp-semibold compare-price">
                                                ${formatMoney(product.variants[0].compare_at_price, shopMoneyFormat)}
                                            </span>
                                            <span class="pp-medium body-sm">
                                                Buy Now
                                            </span>
                                        </button>
                                        
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              `);
          },
          error: function(error) {
              console.error("Error fetching product:", error);
          }
      });
    
  });

            
  function formatMoney(cents, formatKey) {
    if (typeof cents === 'string') { cents = cents.replace('.', ''); }
    cents = parseInt(cents, 10);
    if (isNaN(cents)) return '$0';
  
    var value = '';
    // Define default Shopify-like format strings for each key:
    var formats = {
      amount: '${{ amount }}',
      amount_no_decimals: '${{ amount_no_decimals }}',
      amount_with_comma_separator: '${{ amount_with_comma_separator }}',
      amount_no_decimals_with_comma_separator: '${{ amount_no_decimals_with_comma_separator }}'
    };
  
    // Use provided format key or default to 'amount'
    var formatString = formats[formatKey] || formats.amount;
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = (typeof precision === 'undefined') ? 2 : precision;
      thousands = (typeof thousands === 'undefined') ? ',' : thousands;
      decimal   = (typeof decimal === 'undefined') ? '.' : decimal;
  
      number = (number / 100.0).toFixed(precision);
  
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }
  
    switch (formatKey) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
  
    // Replace the {{ amount }} placeholder with the calculated value
    return formatString.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-slider"] && !Shopify.designMode) return;
  try {
    
    $(window).on('scroll', function () {
        if ($(window).scrollTop() >= 100) {
            $('.header').addClass('scrolled');
        } else {
            $('.header').removeClass('scrolled');
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"] && !Shopify.designMode) return;
  try {
    
  $('.tab-item').on('click', function () {
      var tabType = $(this).data('item');
  
      // Update active tab
      $('.tab-item').removeClass('active');
      $(this).addClass('active');
  
      // Hide all tabs
      $('.products-tab, .articles-tab, .pages-tab').hide();
  
      // Show the selected tab
      if (tabType === 'product') {
        $('.products-tab').show();
      } else if (tabType === 'article') {
        $('.articles-tab').show();
      } else if (tabType === 'page') {
        $('.pages-tab').show();
      }
  });

  const initialItems = 8;
    const itemsPerClick = 4;

    function showInitialItems($tab) {
      const $items = $tab.find('.search-item');
      const $btn = $tab.find('.view-more-btn');

      $items.hide().slice(0, initialItems).show();
      $btn.find('span').text('View More');
      $btn.data('expanded', false);
    }

    // Initialize all tabs
    $('.tab-section').each(function () {
      showInitialItems($(this));
    });

    // View More / Show Less toggle
    $('.view-more-btn').on('click', function () {
      const $btn = $(this);
      const $tab = $btn.closest('.tab-section');
      const $items = $tab.find('.search-item');
      const expanded = $btn.data('expanded');

      if (!expanded) {
        const visibleCount = $items.filter(':visible').length;
        $items.slice(visibleCount, visibleCount + itemsPerClick).slideDown();

        if ($items.filter(':visible').length >= $items.length) {
          $btn.find('span').text('Show Less');
          $btn.data('expanded', true);
          $btn.find('i').removeClass('fa-chevron-down');
          $btn.find('i').addClass('fa-chevron-up');
        }
      } else {
        $items.slice(initialItems).slideUp();
        $btn.find('span').text('View More');
        $btn.data('expanded', false);
        $btn.find('i').removeClass('fa-chevron-up');
        $btn.find('i').addClass('fa-chevron-down');

        $('html, body').animate({
          scrollTop: $tab.offset().top - 150
        }, 500);
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page-single-image-slider"] && !Shopify.designMode) return;
  try {
    
    var top_header_slider = new Swiper('.top-header-slider', {
        slidesPerView: 1,
        loop:false,
        autoHeight: true,
        speed:800,
        fadeEffect: { crossFade: true },
        effect: "fade",
        allowTouchMove: false,
    });


    var mid_image_slider = new Swiper('.mid-image-slider', {
        slidesPerView: 1,
        loop: false,
        speed:800,
        spaceBetween: 25,
        allowTouchMove: true,
        autoHeight: true,
        navigation: {
            nextEl: '.image-content-button-next',
            prevEl: '.image-content-button-prev',
        },
        pagination: {
            el: '.bottom-pagination-slider',
            clickable: true,
            renderBullet: function (index, className) {
                return `<span class="tab-pagination f-f-p-medium t-cap ${className}" data-index="${index}" title="${slideTitles[index]}">${slideTitles[index]}</span>`;
            },
        },
    });

    
    mid_image_slider.controller.control = top_header_slider;

  } catch(e) { console.error(e); }
})();
})();
